var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"p-1"},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.widget))])])]),(false)?_c('cbs-debug',{attrs:{"context":this}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }